<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/newsletter.svg');
            background-position: top !important;
          "
        ></div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("subscribe_to_our_newsletter") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="pt-8">
      <div class="row disablerow align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 innercreatetraining subscription_news">
          <div class="d-flex nls_wrapper">
            <div class="col-md-12 pt-0">
              <div class="mb-6">
                {{ $t("newsletterSubscription_signup_prompt") }}
              </div>
              <div class="">{{ $t("Please_fill_required_information") }}</div>
            </div>

            <div class="col-md-6">
              <span class="fixed-label">{{ $t("email_address") + "*" }}</span>
              <v-text-field
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1 sto_newsletter_select_first"
                dense
                outlined
                v-model="subscription.subscriptionMail"
                :error-messages="validationErrors.subscriptionMail"
                @input="clearEmailError"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <span class="fixed-label">{{ $t("firstname") + "*" }}</span>
              <v-text-field
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1 sto_newsletter_select_first"
                dense
                outlined
                v-model="subscription.firstName"
                :error-messages="validationErrors.firstName"
                @input="clearFirstNameError"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <span class="fixed-label">{{ $t("lastname") + "*" }}</span>
              <v-text-field
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1 sto_newsletter_select_first"
                dense
                outlined
                v-model="subscription.lastName"
                :error-messages="validationErrors.lastName"
                @input="clearLastNameError"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <span class="fixed-label">{{ $t("organization") + "*" }}</span>
              <v-text-field
                hide-details="auto"
                class="datainput justify-content-end align-self-center pb-1 sto_newsletter_select_first"
                dense
                outlined
                v-model="subscription.organisation"
                :error-messages="validationErrors.organisation"
                @input="clearOrganisationError"
              ></v-text-field>
            </div>

            <div class="col-md-6">
              <span class="fixed-label">{{
                $t("preferredLanguage") + "*"
              }}</span>
              <v-select
                class="datainput justify-content-end align-self-center sto_newsletter_select"
                :items="possiblelanguagesComputed"
                item-text="name"
                item-value="value"
                v-model="subscription.preferredLanguage"
                :error-messages="validationErrors.preferredLanguage"
                @change="clearLanguageError"
              >
                <template slot="item" slot-scope="data">
                  <img
                    style="width: 30px; height: 20px; vertical-align: unset"
                    :src="'/files/flags/' + data.item.flag"
                    alt="flag"
                  />
                  &nbsp; {{ data.item.name }}
                </template>
                <template slot="selection" slot-scope="{ item }">
                  <img
                    style="width: 30px; height: 20px; vertical-align: unset"
                    :src="'/files/flags/' + item.flag"
                    alt="flag"
                  />
                  &nbsp; {{ item.name }}
                </template>
              </v-select>
            </div>
            <div class="col-md-12 cb_mandatory">
              <v-checkbox
                v-model="subscription.agreeToTerms"
                :label="$t('confirm_terms_and_conditions')"
                :error-messages="validationErrors.agreeToTerms"
                @change="clearAgreeToTermsError"
              ></v-checkbox>
              <div class="text-right">
                <v-label> * {{ $t("mandatory_fields") }} </v-label>
              </div>
            </div>

            <div class="col-md-12">
              <v-card-actions class="p-0">
                <v-btn
                  @click="handleClick"
                  outlined
                  depressed
                  tile
                  class="savebutton"
                >
                  {{ $t("subscribe") }}
                </v-btn>
              </v-card-actions>
            </div>
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-3 ml-1 px-0 pl-md-12 pl-lg-8 row pt-0 onlyContact">
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      subscription: {
        firstName: "",
        lastName: "",
        subscriptionMail: "",
        preferredLanguage: null,
        organisation: "",
        agreeToTerms: null,
      },
      validationErrors: {
        firstName: "",
        lastName: "",
        subscriptionMail: "",
        preferredLanguage: "",
        organisation: "",
        agreeToTerms: "",
      },
    };
  },

  mounted() {
    if (
      this.isLoad != true &&
      !window.location.href.includes("?") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;
      window.location.href =
        window.location.href + "?lang=" + this.$locale.toUpperCase();
    }
    this.subscriptionId = this.$route.query.subscriptionId;
    if (this.$route.query.stayData) {
      const savedData = sessionStorage.getItem("subscriptionData");
      this.subscription = JSON.parse(savedData);
    }
    if (this.subscriptionId) {
      this.finalSubscrptionConfirmation(this.subscriptionId);
    }
  },

  computed: {
    possiblelanguagesComputed() {
      return this.$root.languageTabsNew.map((language) => ({
        name: language.translatedName,
        flag: language.flag,
        shortForm: language.shortForm,
        value: language.language,
      }));
    },
  },
  methods: {
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    onFinally() {
      showLoadingCircle(false);
    },
    validateEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
    clearFirstNameError() {
      if (this.subscription.firstName.trim()) {
        this.validationErrors.firstName = "";
      }
    },
    clearLastNameError() {
      if (this.subscription.lastName.trim()) {
        this.validationErrors.lastName = "";
      }
    },
    clearOrganisationError() {
      if (this.subscription.organisation.trim()) {
        this.validationErrors.organisation = "";
      }
    },
    clearEmailError() {
      if (this.validateEmail(this.subscription.subscriptionMail.trim())) {
        this.validationErrors.subscriptionMail = "";
      }
    },
    clearLanguageError() {
      if (this.subscription.preferredLanguage) {
        this.validationErrors.preferredLanguage = "";
      }
    },
    clearAgreeToTermsError() {
      if (this.subscription.agreeToTerms) {
        this.validationErrors.agreeToTerms = "";
      }
    },
    handleClick() {
      // Reset validation errors
      this.validationErrors.subscriptionMail = "";
      this.validationErrors.preferredLanguage = "";
      this.validationErrors.firstName = "";
      this.validationErrors.lastName = "";
      this.validationErrors.organisation = "";
      this.validationErrors.agreeToTerms = "";

      let isValid = true;

      if (!this.subscription.firstName.trim()) {
        this.validationErrors.firstName = this.$t("valid_first_name");
        isValid = false;
      }
      if (!this.subscription.lastName.trim()) {
        this.validationErrors.lastName = this.$t("valid_last_name");
        isValid = false;
      }
      // Validate email
      if (
        !this.subscription.subscriptionMail ||
        !this.validateEmail(this.subscription.subscriptionMail.trim())
      ) {
        this.validationErrors.subscriptionMail = this.$t("valid_email");
        isValid = false;
      }

      if (!this.subscription.organisation.trim()) {
        this.validationErrors.organisation = this.$t("valid_organisation");
        isValid = false;
      }

      // Validate language selection
      if (!this.subscription.preferredLanguage) {
        this.validationErrors.preferredLanguage = this.$t(
          "select_prefred_language"
        );
        isValid = false;
      }

      if (!this.subscription.agreeToTerms) {
        this.validationErrors.agreeToTerms = this.$t("must_accept_terms");
        isValid = false;
      }

      if (isValid) {
        this.confirmSubscription();
      }
    },
    confirmSubscription() {
      this.subscription.subscriptionMail =
        this.subscription.subscriptionMail.trim();
      this.subscription.firstName = this.subscription.firstName.trim();
      this.subscription.lastName = this.subscription.lastName.trim();
      this.subscription.organisation = this.subscription.organisation.trim();

      sessionStorage.setItem(
        "subscriptionData",
        JSON.stringify(this.subscription)
      );
      this.subscription.subscriptionMail = null;
      this.subscription.preferredLanguage = null;
      this.subscription.firstName = null;
      this.subscription.lastName = null;
      this.subscription.organisation = null;
      this.$router.push("/confirm-subscription");
    },
  },
};
</script>
